// ----------------------------------------------------------------------

function path(root, sublink) {
  return `${root}${sublink}`;
}

const ROOTS_AUTH = '/auth';
const ROOTS_DASHBOARD = '/tools';

// ----------------------------------------------------------------------

export const PATH_AUTH = {
  root: ROOTS_AUTH,
  login: path(ROOTS_AUTH, '/login'),
  loginUnprotected: path(ROOTS_AUTH, '/login-unprotected'),
  register: path(ROOTS_AUTH, '/register'),
  registerUnprotected: path(ROOTS_AUTH, '/register-unprotected'),
  resetPassword: path(ROOTS_AUTH, '/reset-password'),
  verify: path(ROOTS_AUTH, '/verify')
};

export const PATH_PAGE = {
  root: ('', ''),
  comingSoon: '/coming-soon',
  login: '/login',
  register: '/register',
  account: '/account',
  verifikasi: '/verifikasi',
  maintenance: '/maintenance',
  pricing: '/pricing',
  aktivasi: path('/', '/aktivasi'),
  payment: '/payment',
  about: '/about-us',
  contact: '/contact-us',
  prosedur: '/prosedur',
  faqs: '/faqs',
  ProductDetails: path('/', 'ProductDetails'),
  lelang: path('/', '/lelang'),
  lelangkpknl: path('/', '/lelangkpknl'),
  lelangaset: path('/', '/lelang:name'),
  list: path('/', '/list'),
  page404: '/404',
  page500: '/500',
  components: '/components'
};

export const PATH_DASHBOARD = {
  root: ROOTS_DASHBOARD,
  general: {
    app: path(ROOTS_DASHBOARD, '/app'),
    asset: path(ROOTS_DASHBOARD, '/assetlist'),
    wishlistall: path(ROOTS_DASHBOARD, '/wishlistall'),
    newasset: path(ROOTS_DASHBOARD, '/assetnew'),
    ProductApprove: path('/', 'ProductApprove'),
    ecommerce: path(ROOTS_DASHBOARD, '/ecommerce'),
    analytics: path(ROOTS_DASHBOARD, '/analytics'),
    reportbmpp: path(ROOTS_DASHBOARD, '/reportbmpp'),
    banking: path(ROOTS_DASHBOARD, '/banking')
  },
  mail: {
    root: path(ROOTS_DASHBOARD, '/mail'),
    all: path(ROOTS_DASHBOARD, '/mail/all')
  },
  chat: {
    root: path(ROOTS_DASHBOARD, '/chat'),
    new: path(ROOTS_DASHBOARD, '/chat/new'),
    conversation: path(ROOTS_DASHBOARD, '/chat/:conversationKey')
  },
  calendar: path(ROOTS_DASHBOARD, '/calendar'),
  kanban: path(ROOTS_DASHBOARD, '/kanban'),
  bmpp: {
    root: path(ROOTS_DASHBOARD, '/bmpp'),
    list: path(ROOTS_DASHBOARD, '/bmpp/bmpplist'),
    newPengurus: path(ROOTS_DASHBOARD, '/bmpp/pengurusnew')
  },
  glossary: {
    root: path(ROOTS_DASHBOARD, '/glossary'),
    list: path(ROOTS_DASHBOARD, '/glossary/pbilist'),
    newPbi: path(ROOTS_DASHBOARD, '/glossary/pbinew'),
    memolist: path(ROOTS_DASHBOARD, '/glossary/memolist'),
    newmemo: path(ROOTS_DASHBOARD, '/glossary/memonew'),
    informasilist: path(ROOTS_DASHBOARD, '/glossary/informasilist'),
    newinformasi: path(ROOTS_DASHBOARD, '/glossary/informasinew')
  },
  user: {
    root: path(ROOTS_DASHBOARD, '/user'),
    profile: path(ROOTS_DASHBOARD, '/user/profile'),
    cards: path(ROOTS_DASHBOARD, '/user/cards'),
    list: path(ROOTS_DASHBOARD, '/user/list'),
    newUser: path(ROOTS_DASHBOARD, '/user/new'),
    editById: path(ROOTS_DASHBOARD, `/user/reece-chung/edit`),
    account: path(ROOTS_DASHBOARD, '/user/account')
  },
  referensi: {
    root: path(ROOTS_DASHBOARD, '/referensi'),
    kpknl: path(ROOTS_DASHBOARD, '/referensi/kpknl'),
    newkpknl: path(ROOTS_DASHBOARD, '/referensi/kpknlnew'),
    kategori: path(ROOTS_DASHBOARD, '/referensi/kategori'),
    contactperson: path(ROOTS_DASHBOARD, '/referensi/contactperson'),
    newcontactperson: path(ROOTS_DASHBOARD, '/referensi/contactpersonnew'),
    newkategori: path(ROOTS_DASHBOARD, '/referensi/kategorinew'),
    advertising: path(ROOTS_DASHBOARD, '/referensi/advertising'),
    newadvertising: path(ROOTS_DASHBOARD, '/referensi/advertisingnew')
  },
  pages: {
    root: path(ROOTS_DASHBOARD, '/pages'),
    prosedur: path(ROOTS_DASHBOARD, '/pages/prosedur'),
    faq: path(ROOTS_DASHBOARD, '/pages/faq'),
    disclaimer: path(ROOTS_DASHBOARD, '/pages/disclaimer')
  },
  eCommerce: {
    root: path(ROOTS_DASHBOARD, '/e-commerce'),
    shop: path(ROOTS_DASHBOARD, '/shop'),
    product: path(ROOTS_DASHBOARD, '/e-commerce/product/:name'),
    productById: path(ROOTS_DASHBOARD, '/e-commerce/product/nike-air-force-1-ndestrukt'),
    list: path(ROOTS_DASHBOARD, '/e-commerce/list'),
    newProduct: path(ROOTS_DASHBOARD, '/e-commerce/product/new'),
    editById: path(ROOTS_DASHBOARD, '/e-commerce/product/nike-blazer-low-77-vintage/edit'),
    checkout: path(ROOTS_DASHBOARD, '/e-commerce/checkout'),
    invoice: path(ROOTS_DASHBOARD, '/e-commerce/invoice')
  },
  blog: {
    root: path(ROOTS_DASHBOARD, '/blog'),
    posts: path(ROOTS_DASHBOARD, '/blog/posts'),
    post: path(ROOTS_DASHBOARD, '/blog/post/:title'),
    postById: path(ROOTS_DASHBOARD, '/blog/post/apply-these-7-secret-techniques-to-improve-event'),
    newPost: path(ROOTS_DASHBOARD, '/blog/new-post')
  }
};

export const PATH_DOCS = '#';
